import { render, staticRenderFns } from "./StudentLogin.vue?vue&type=template&id=2991429e&scoped=true&lang=pug&"
import script from "./StudentLogin.vue?vue&type=script&lang=ts&"
export * from "./StudentLogin.vue?vue&type=script&lang=ts&"
import style0 from "./StudentLogin.vue?vue&type=style&index=0&id=2991429e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2991429e",
  null
  
)

export default component.exports